<template>
  <div class="card main-content">
    <div class="grid">
        <div class="sm:col-12 md:col-12 lg:col-12">
            <div class="flex ">
                <div class="flex-initial flex justify-content-center w-full ml-3 mr-3 ">
                    <div class="surface-card shadow-2 p-3 border-round-xl w-full mt-4 ">
                        <div class="field font-medium text-lg w-full">
                            <div class="flex justify-content-between flex-wrap">
                                <div class="flex align-items-center justify-content-center font-semibold text-lg  ml-2">                                        
                                        Re-Located Challans                                   
                                </div>
                                <div class="flex align-items-center justify-content-center mr-3 mt-2"> 
                                    <InputText v-model="filterQuery" placeholder="Keyword Search" size="small" ></InputText>
                                </div>                                     
                            </div>
                            <div class="flex justify-content-between flex-wrap">
                                <div class="flex align-items-center justify-content-center font-semibold text-lg  ml-2">                                        
                                    <Button label="Create Challan" :icon="loaderIcon" size="small" raised @click="toggleChallanDialog"></Button>                             
                                </div>
                                <div class="flex align-items-center justify-content-center mr-3 mt-2"> 
                                    
                                    <Button class="ml-2" icon="pi pi-filter" severity="success" raised size="small" @click="globalFilter" v-tooltip.top="'Search'" ></Button>
                                    <Button class="ml-2" icon="pi pi-filter-slash" size="small" outlined raised severity="success" @click="clearFilter" v-tooltip.top="'Clear result'" ></Button> 
                                </div>
                            </div>
                        </div>

                        <div class="field col">
                            <DataTable ref="reLocatedChallans" exportFilename="relocated_challans" :value="filteredDcList" stripedRows  size="small" :loading="tableLoading" v-model:filters="filters"  dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="30rem" v-model:expandedRows="expandedRows" @rowExpand="onRowExpand" @rowCollapse="onRowCollapse">

                                <Column expander style="width: 5rem"/>
                                <Column field="dcNo" header="Challan No."></Column>
                                <Column field="dcDate" header="Date"></Column>
                                <Column field="dept.shortCode" header="Department"></Column>
                                <Column field="deptPo" header="Order No."></Column>
                                <Column field="location.name" header="Location"></Column>
                                <Column field="dcValue" header="Value">
                                    <template #body="slotProps">
                                        {{formatCurrency(slotProps.data.dcValue)}}
                                    </template>
                                </Column>
                                <Column field="givenStatus" header="Given">
                                    <template #body="slotProps">
                                        <Button v-if="slotProps.data.givenStatus==0" size="small" label="Give Out" icon="pi pi-sign-out" class="px-2 py-1" severity="danger" text raised @click="showGiveOutDialog(slotProps.data)"></Button>
                                        <Tag v-if="slotProps.data.givenStatus==1" value="Given" severity="success" ></Tag>
                                    </template>
                                </Column>
                                <Column field="recdStatus" header="Received">
                                <template #body="slotProps">
                                    <Button v-if="slotProps.data.givenStatus==1 && slotProps.data.recdStatus==0" size="small" label="Update Recd" class="px-2 py-1" severity="help" raised text @click="showRecdDcDialog(slotProps.data)"></Button>
                                        <Tag v-if="slotProps.data.givenStatus==0" value="Not Received" severity="danger" ></Tag>
                                        <Tag v-if="slotProps.data.recdStatus==1" value="Received" severity="success" ></Tag>                            
                                    </template>
                                </Column>
                                <Column header="Action">                                    
                                    <template #body="slotProps">
                                        <div class="flex">
                                            <div class="flex-initial flex align-items-center justify-content-center">
                                                <router-link :to="{
                                                    name: 'DeliveryChallanPdf',
                                                    params:{
                                                        id:slotProps.data.id,
                                                    }
                                                }" target="_blank" rel="noopener">
                                                     <Button size="small" icon="pi pi-print" text raised  v-tooltip.top="'Print'"/>
                                                </router-link>
                                            </div>
                                            <div class="flex-initial flex align-items-center justify-content-center">
                                                <Button icon="pi pi-times" severity="danger" size="small"  rounded text v-tooltip.top="'Cancel DC'" @click="showCancelDialog(slotProps.data)" ></Button>
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                                <Column field="billStatus" header="Bill Status">
                                    <template #body="slotProps">
                                        <Tag v-if="slotProps.data.billStatus==0" value="Not Billed" severity="warning" />
                                        <Tag v-if="slotProps.data.billStatus!=0" :value="slotProps.data.billStatus" severity="success" />
                                    </template>
                                </Column>

                                <template #expansion="slotProps">
                                    <DataTable :value="slotProps.data.dcItems" >
                                        <Column field="name" header="Item"/>
                                        <Column field="hsn" header="HSN"/>
                                        <Column field="packing" header="Packing">
                                            <template #body="slotProps">
                                                {{ slotProps.data.packing }}
                                            </template>                                        
                                        </Column>
                                        <Column field="qty" header="Quantity"/>
                                        <Column field="modelNo" header="Model">
                                            <template #body="slotProps">
                                                {{ slotProps.data.modelNo }}
                                            </template>                                        
                                        </Column>
                                        <Column field="partNo" header="Part/Sr No.">
                                            <template #body="slotProps">
                                                {{ slotProps.data.partNo }}
                                            </template>                          
                                        </Column>
                                        <Column field="batch_no" header="Batch">
                                            <template #body="slotProps">
                                                {{ slotProps.data.batch_no }}
                                            </template>                          
                                        </Column>
                                        <Column field="mfgDate" header="Mfg Date">
                                            <template #body="slotProps">
                                                {{ slotProps.data.mfgDate }}
                                            </template>                            
                                        </Column>
                                        <Column field="expDate" header="Exp Date">
                                            <template #body="slotProps">
                                                {{slotProps.data.expDate}}
                                            </template>                                        
                                        </Column>                                        
                                        <Column field="prevLocation" header="Prev Locat.">
                                            <template #body="slotProps">
                                                {{slotProps.data.prevLocation}}
                                            </template>                                        
                                        </Column>
                                        <Column field="prevChallan" header="Prev Challan">
                                            <template #body="slotProps">
                                                {{slotProps.data.prevChallan}}
                                            </template>                                        
                                        </Column>
                                    </DataTable>
                                </template>

                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- dialog -->
<Dialog :visible="newChallanDialog" modal :closable="false" :style="{ width: '90vw' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">

    <template #header>
        <div class="flex align-items-center gap-2">
        <span class="font-semibold text-xl">New Challan</span>
        <Tag value="Re-Location" severity="warning" />
        </div>
    </template>
    <Divider />

    <div class="flex">
        <div class="sm:col-6 md:col-6 lg:col-6">
            
            <DataTable ref="pendingItems" :value="filteredItems" stripedRows showGridlines size="small" :loading="table2Loading" v-model:filters="filters2" v-model:selection="selectedItem" dataKey="id" paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" currentPageReportTemplate="{first} to {last} of {totalRecords}" scrollable scrollHeight="55vh" @row-select="addItemsDc" @row-unselect="removeItemDc">

                <template #header >
                    <div class="flex justify-content-between flex-wrap">
                        <div class="flex align-items-center justify-content-center text-base">
                            Items Pending Re-Location
                        </div>
                        <div class="flex align-items-center justify-content-center">
                            <Dropdown class="mr-2" v-model="selectedBillingStatus" filter :options="billingOptions" optionLabel="name" optionValue="id" placeholder="Bill Status" @change="filterBilledNotBilled" showClear></Dropdown>

                            <Button label="Reset" size="small" raised severity="warning" class="mr-2" @click="getPendingItems"/>

                            <InputText v-model="filters2['global'].value" size="small" placeholder="Keyword Search" />
                        </div>
                    </div>
                </template>

                <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                <Column field="name" header="Item"></Column>
                <Column field="quantity" header="Quantity"></Column>
                <Column field="deptPoNo" header="Order"></Column>
                <Column field="hsn" header="HSN"></Column>
                <Column field="batchNo" header="Batch"></Column>
                <Column field="mfgDate" header="Mfg"></Column>
                <Column field="expDate" header="Exp"></Column>
                <Column field="modelNo" header="Model"></Column>
                <Column field="partNo" header="Part/Serial"></Column>
                <Column header="Show DL">
                    <template #body="slotProps">
                            <Button label="Show" class="btn-scale-0"  icon="pi pi-external-link" raised @click="showLocations(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>

        </div>
        <!-- <Divider layout="vertical" /> -->
        <div class="sm:col-6 md:col-6 lg:col-6">

            <div class="grid">
                <div class="col-12">
                    <div class="formgrid grid mr-2">
                        <div class="field col">
                            <label class="text-base font-semibold">Location:</label>
                            
                            <Dropdown class="w-full" v-model="selectedLocation" filter :options="filteredLocations" optionLabel="name" placeholder="Select location" @change="filterLocationItem"/>
                        </div>
                        <div class="field col">
                            <label class="text-base font-semibold">Challan Date:</label>
                            <Calendar v-model="challanDate" placeholder="Select date"/>
                        </div>
                        <div class="field col">
                            <label class="text-base font-semibold">Department:</label>
                            <Dropdown class="w-full" v-model="selectedDepartment" filter :options="departments" optionLabel="name" placeholder="Select department" />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="formgrid grid mr-2">            
                        <div class="field col">
                            <label class="text-base font-semibold">Department Order:</label>
                            <InputText v-model="deptPoNo" class="w-full" disabled="true"/>
                        </div>
                        <!-- <div class="field col">
                            <label >Order date:</label>
                            <InputText v-model="orderDate" class="w-full" disabled="true"/>
                        </div> -->
                    </div>
                </div>
                <div class="col-12">
                    <div class="formgrid grid mr-2">            
                        <div class="field col">
                            <div class="flex justify-content-left flex-wrap">
                                <div class="flex align-items-center justify-content-center">
                                    <label class="text-base font-semibold">
                                        Challan Items
                                    </label>
                                </div>
                            </div>
                            <!-- <Panel header="Challan Items"> -->
                                <ScrollPanel style="height:40vh" class="mb-6" >
                                    <div v-if="dcItems.length == 0" class="mx-3 mt-3">
                                        <span >Please select items from the pending list to be added to Delivery Challan.</span>
                                    </div>
                                    <DcItem v-for="(item, index) in dcItems" :key="index" :sl="index+1" :item="item" @bind-item="bindData" class="mx-3 mt-3"/>
                                </ScrollPanel>
                            <!-- </Panel> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>      

  <template #footer>
      <div class="flex justify-content-end flex-wrap">
          <div class="flex align-items-center justify-content-center">
              <Button label="Save" raised severity="success" size="small" @click="saveChallan" class="mx-2" ></Button>
              <Button label="Cancel" text raised severity="secondary" size="small" @click="toggleChallanDialog"></Button>
          </div>
      </div>
  </template>
</Dialog>  
<!-- dialog end -->

<Dialog :visible="locationDialog" modal :closable="false" :header="locationDialogHeader" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
                                            
    <DataTable :value="itemDeliveryLocations"  tableStyle="min-width: 30rem">
        <Column field="location" header="Location"></Column>
        <Column field="quantity" header="Quantity"></Column>
        <Column field="deliveredQty" header="Delivered Qty"></Column>
        
    </DataTable>
    <div class="flex justify-content-end flex-wrap">
    <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="danger" @click="locationDialog=false"></Button>
    </div>
</Dialog>

<!-- give out dialog -->
<Dialog :visible="giveOutDcDialogVisibility" modal :closable="false" header="Give out Delivery Challan?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">         
    
        <div class="flex justify-content-end flex-wrap">
            <div class="flex align-items-center justify-content-center pr-3">
                <i v-if="spinnerLoadingStatus" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
        </div>
    
        <div class="flex">
            <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-sign-out" style="font-size: 2.5rem"></i></div>
            <div class="flex align-items-center justify-content-center ">
                <p> DC No.: <strong>{{dcNo}}</strong><br> Once given, Dept PO stock would be updated.</p>
            </div>                              
        </div>
    <div class="flex justify-content-end flex-wrap">
        <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Cancel" outlined severity="secondary" @click="giveOutDcDialogVisibility=false"></Button>
        <Button class="my-1 py-2" label="Yes" severity="success" @click="updateGivenAndStock" />
    </div>
</Dialog>

<!-- update recd dc -->
<Dialog :visible="recdDcDialogVisibility" modal :closable="false" header="Received Signed Delivery Challan?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">             
    <div class="flex justify-content-end flex-wrap">
        <div class="flex align-items-center justify-content-center pr-3">
            <i v-if="spinnerLoadingStatus" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </div>
    </div>           
    <div class="flex">
        <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-sign-in" style="font-size: 2.5rem"></i></div>
        <div class="flex align-items-center justify-content-center ">
            <p> DC No.: <strong>{{dcNo}}</strong><br> Once received, Challan won't be editable.</p>
        </div>                              
    </div>
    <div class="flex justify-content-end flex-wrap">
        <Button class="flex align-items-center justify-content-center my-1 mr-2" size="small" label="Cancel" outlined severity="secondary" @click="recdDcDialogVisibility=false"></Button>
        <Button class="my-1 py-2" label="Yes" severity="success" @click="updateRecdChallan" />
    </div>
</Dialog>
<!-- update recd dc end -->

<!-- cancel dc dialog statrt -->
<Dialog :visible="cancelDcDialogVisibility" modal :closable="false" header="Are you sure?" :style="{ width: '30rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    
        <div class="flex justify-content-end flex-wrap">
            <div class="flex align-items-center justify-content-center pr-3">
                <i v-if="spinnerLoadingStatus" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
        </div>

        <div class="flex">
            <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
            <div class="flex align-items-center justify-content-center ">
                <p> DC No.: <strong>{{dcNo}}</strong>
                <br>This will cancel the Delivery Challan!
                <br>Items would be revoked to previous state. </p>
            </div>                              
        </div>
        <div class="formgrid grid">
            <div class="field col">
            <label >Remarks:</label>
            <Textarea v-model="cancelRemark" rows="5" cols="45" />
            </div>
        </div>

    <div class="flex justify-content-end flex-wrap">
        <Button class="my-1 py-2 mr-2" label="Cancel DC" severity="danger" @click="cancelDeliveryChallan" />
        <Button class="flex align-items-center justify-content-center my-1 " size="small" label="Close" outlined severity="secondary" @click="cancelDcDialogVisibility=false"></Button>
    </div>
</Dialog>
<!-- cancel dc dialog end -->

</template>

<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
// import Panel from 'primevue/panel';
import Tag from 'primevue/tag';
import DcItem from '../deliveryChallan/deliveryChallanItem.vue'
import { cancelDc, getDeliveryLocations, getDepartments, getReLocationChallan, getReLocationPendingItems, revokeNewChallan, storeReLocation, updateDcStatusAndStock, updateRecdDc } from '@/services/apiService';
import { FilterMatchMode } from 'primevue/api'
import ScrollPanel from 'primevue/scrollpanel';
import Textarea from 'primevue/textarea';

export default {
    components:{
        Button,
        Calendar,
        Column,
        DataTable,
        Dialog,
        Divider,
        Dropdown,
        InputText,
        // Panel,
        Tag,
        DcItem,
        ScrollPanel,
        Textarea,
        // ChallanPrintComponent,
    },
    data(){
        return{
            newChallanDialog:false,
            dialogHeader:null,
            tableData:[],
            filteredDcList:[],
            expandedRows:[],
            tableLoading:false,
            filters2: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.IN },
                batchNo: { value: null, matchMode: FilterMatchMode.IN },
                modelNo: { value: null, matchMode: FilterMatchMode.IN },
            },
            pendingItems:[],
            table2Loading:false,
            filters:null,
            selectedLocation:null,
            filteredLocations:[],
            locations2:[],
            challanDate:null,
            selectedDepartment:null,
            departments:[],
            deptPoNo:null,
            deptPo:null,
            orderDate:null,
            dcItems:[],
            filterFlag:0,
            filteredItems:[],
            poFilteredItem:[],
            selectedItem:[],
            loaderIcon:'pi pi-plus',
            locationDialog:false,
            locationDialogHeader:null,
            itemDeliveryLocations:[],
            dcId:null,
            cpcKey:0,
            isVisible:false,
            bodyHtml:null,
            giveOutDcDialogVisibility:false,
            dc:null,
            dcNo:null,
            spinnerLoadingStatus:false,
            selectedBillingStatus:null,
            billingOptions:[
                { name:'Billed', id:1},
                { name:'Not Billed', id:0},
            ],
            recdDcDialogVisibility:false,
            filterQuery:null,
            cancelRemark:null,
            cancelDcDialogVisibility:false,
        }
    },
    mounted(){
        this.index();
        this.getLocations();
        // this.getPendingItems();
        this.getDepts();
    },  
    methods:{
        async index(){
            this.filteredDcList = [];
            this.tableLoading = true;
            try {
            const query = '?cancel[eq]=0&reLocation[eq]=1';
                const response = await getReLocationChallan(query);   
                this.tableData = response.data;
                this.tableData.forEach(e => {
                    let dcAmt = 0;
                    e.dcItems.forEach(l => {
                    dcAmt += (l.deptRate * l.qty) + (((l.deptRate * l.qty)/100)*l.gstRate);
                    });
                    this.filteredDcList.push({
                        ...e,
                        dcValue:dcAmt,
                        });                    
                });
                this.tableData = this.filteredDcList;                
                this.tableLoading = false;
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.tableLoading = false;
            }
        },
        async toggleChallanDialog(){ 
            this.loaderIcon = 'pi pi-spin pi-spinner';           
            if(!this.newChallanDialog){ 
                  try {
                    await this.getPendingItems();
                    this.newChallanDialog = true;
                    this.loaderIcon = 'pi pi-plus';
                  } catch (error) {
                    this.showErrorToast({message:'Error fetching pending items: ',error});
                    this.loaderIcon = 'pi pi-plus';
                  }             
            }
            else{
                this.newChallanDialog = false;
                this.loaderIcon = 'pi pi-plus';
            }
        },
        getLocations(){            
            getDeliveryLocations([]).then((res)=>{               
                this.filteredLocations = res.data;
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            });
        },
        getDepts(){
            getDepartments().then((res2)=>{
                this.departments = res2.data;                
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        async getPendingItems(){
            this.table2Loading = true;
            this.pendingItems = [];
            this.filteredItems = [];
            this.poFilteredItem = [];
            this.dcItems = [];
            this.selectedItem = [];
            this.deptPoNo = 'Add items to Delivery Challan';
            this.challanDate = null;
            this.selectedDepartment = null;
            this.selectedBillingStatus = null;
            this.filterFlag = 0;
            try {
                const res = await getReLocationPendingItems();                 
                this.pendingItems = res.data;
                this.filteredItems = res.data;
            } catch (error) {
                this.showErrorToast(error.response?.data || {message:'Failed to fetch pending items.'});
            } finally{
                this.table2Loading = false;
            }
        },
        filterBilledNotBilled(){
            this.filteredItems = [];            
            if(this.selectedBillingStatus == 1){
                this.filteredItems = this.pendingItems.map(e=>{                    
                    if(e.billId != null){
                        return e;
                    }       
                })
            }

            if(this.selectedBillingStatus == 0){
                this.filteredItems = this.pendingItems.map(e=>{                    
                    if(e.billId == null){
                        return e;
                    }       
                })
            }
        },
        addItemsDc(event){                       
            const data = event.data;
            const billStatus = event.data.billId;            
            this.setBillingStatus(billStatus)

            // filtering items and location based on item selection
            if(this.filterFlag==0){
                this.filteredItems = [];
                this.filteredLocations = [];

                // filter items based on dept po                
                this.pendingItems.forEach(e => {                                        
                    if(data.deptPoNo == e.deptPoNo && (billStatus == null ? e.billId == null : e.billId != null)){                    
                        this.filteredItems.push(e);

                        // filter delivery locations
                        e.location.forEach(el => {
                            this.filteredLocations.push({
                                 'id':el.id,
                                 'locationId':el.locationId,
                                 'name':el.location,
                                 'name2':el.location+' ('+el.quantity+')',
                            });
                        });
                    }
                });

                this.locations2 = this.filteredLocations;
                this.filteredLocations = [];            
                this.locations2.every(e => {
                    if(this.filteredLocations.length == 0){
                        this.filteredLocations.push(e);
                    }
                    else{
                        let flag = 0;
                        this.filteredLocations.every(el => {
                            if(e.locationId == el.locationId){
                                flag = 1;
                                return false;
                            }
                            return true;
                        });
                        if(flag==0){
                            this.filteredLocations.push(e);
                        }
                    }
                    return true;
                });                
                this.poFilteredItem = [];
                this.poFilteredItem = this.filteredItems;                
                this.deptPoNo = data.deptPoNo;
                this.deptPo = data.deptPo;
                this.filterFlag = 1;
            }

            this.dcItems.push({
                ...data,
                availableQty:data.quantity,
                avalQty:data.quantity,
                totalQty:data.quantity,
            });

        },
        setBillingStatus(option){
            if(option == null){
                this.selectedBillingStatus = 0;
            }
            else{
                this.selectedBillingStatus = 1;
            }
        },
        removeItemDc(event){
            const index = this.dcItems.findIndex((e)=>e.id ==event.data.id);
            this.dcItems.splice(index, 1);
        },
        filterLocationItem(){
            this.filteredItems = [];
            if(this.poFilteredItem.length === 0){
                this.pendingItems.forEach(e => {
                    e.location.every(lo => {                        
                        if(lo.locationId == this.selectedLocation.locationId){
                            this.filteredItems.push(e);
                            return false;
                        }
                        return true;
                    });
                });
            }
            else{
                this.poFilteredItem.forEach(e => {
                    e.location.every(lo => {                        
                        if(lo.locationId == this.selectedLocation.locationId){
                            this.filteredItems.push(e);
                            return false;
                        }
                        return true;
                    });
                });
            }
        },
        bindData(itemId, itemData){
            const item = this.dcItems.find((e) => e.id == itemId);
            item.packing = itemData.itemUom;
            item.batchNo = itemData.itemBatch;
            item.partNo = itemData.itemPart;
            item.modelNo =itemData.itemModel;
            // item.quantity = itemData.itemQuantity;
            item.availableQty = itemData.itemQuantity;
            item.avalQty = itemData.itemAvailQty;
        },
        async saveChallan(){    
            if(this.selectedLocation==null){
                return this.showErrorToast({message:'Delivery location not selected!'});
            }
            if(this.challanDate==null){
                return this.showErrorToast({message:'Select a challan date!'});
            }
            if(this.selectedDepartment==null){
                return this.showErrorToast({message:'Department not selected!'});
            }
            if(this.dcItems.length==0){
                return this.showErrorToast({message:'Please add at-least one item to challan!'});
            }

            const data = {
                'reLocation':'1',
                'dept':this.selectedDepartment.id,
                'dcDate':this.challanDate.getFullYear()+'-'+(this.challanDate.getMonth()+1)+'-'+this.challanDate.getDate(),
                'deliveryLocation':this.selectedLocation.locationId,
                'deptPo':this.deptPo.uuid,
                'dcItems':this.dcItems,
                'billId':this.dcItems[0].billId,
            }

            try {
                const response = await storeReLocation(data);
                this.toggleChallanDialog()
                this.clearDialog();
                this.showSuccessToast(response.data);                
                this.index();
            } catch (error) {
                this.showErrorToast(error.response.data);              
            }            
        },
        clearDialog(){
            this.selectedDepartment = null;
            this.challanDate = null;
            this.selectedLocation = null;
            this.deptPo = null;
            this.dcItems = [];
        },  
        showGiveOutDialog(data){
            this.giveOutDcDialogVisibility = true;
            this.dc = data;
            this.dcNo = data.dcNo;
        },
        updateGivenAndStock(){
            const data = {
            'dcId':this.dc.id,
            'dcItems':this.dc.dcItems,
            'location':this.dc.location,
            }
            
            this.spinnerLoadingStatus = true;
            
            updateDcStatusAndStock(data).then((res)=>{
                this.showSuccessToast(res.data);
                this.spinnerLoadingStatus = false;
                this.giveOutDcDialogVisibility = false;
                this.dc = null;
                this.index();
            }).catch((error)=>{
                const errMsg = error?.response?.data?.message || error?.message || 'An error occurred';
                this.showErrorToast({message:errMsg});
                this.spinnerLoadingStatus = false;
                this.dc = null;
            })
        },
        showRecdDcDialog(data){
            this.recdDcDialogVisibility = true;
            this.dc = data;
            this.dcNo = data.dcNo;
        },
        updateRecdChallan(){
            this.spinnerLoadingStatus = true;
            updateRecdDc({id:this.dc.id}).then((res)=>{
                this.showSuccessToast(res.data);
                this.spinnerLoadingStatus = false;
                this.recdDcDialogVisibility = false;
                this.index();
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
                this.spinnerLoadingStatus = false;
            })
        },
        showCancelDialog(data){
            this.cancelDcDialogVisibility = true;
            this.dc = data;
            this.dcNo = data.dcNo;
            this.cancelRemark = null;
        },
        async cancelDeliveryChallan(){
            const data = {
            'dcId':this.dc.id,
            'location':this.dc.location.locationId,
            'dcNo':this.dc.dcNo,
            'dcItems':this.dc.dcItems,
            'givenStatus':this.dc.givenStatus,
            'remarks':this.cancelRemark,
            'deptId':this.dc.dept.id,
            }        
            
            this.spinnerLoadingStatus = true;

            try {
                const response = await cancelDc(data);
                this.showSuccessToast(response.data);
                const response2 = await revokeNewChallan(this.dc.dcItems); 
                this.showSuccessToast(response2.data);
                this.cancelDcDialogVisibility = false;
                this.spinnerLoadingStatus = false;
                this.index();
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.cancelDcDialogVisibility = false;
                this.spinnerLoadingStatus = false;
            }
        },
        globalFilter(){            
            this.filteredDcList = [];
            const condition = new RegExp(this.filterQuery, 'giv')
            if(this.filterQuery!=null){
                this.tableData.forEach(e => {     
                    if (e.dcNo.match(condition) || e.deptPo.match(condition) || e.dept.name.match(condition) || e.location.name.match(condition) || e.billStatus.match(condition)) { 
                    this.filteredDcList.push(e); 
                    }
                    else{
                        e.dcItems.every(el => { 
                            if(el.name.match(condition) || (el.batch_no ? el.batch_no.match(condition) : false ) || (el.partNo ? el.partNo.match(condition) : false) || (el.modelNo ? el.modelNo.match(condition) : false)){
                                this.filteredDcList.push(e);
                                return false;
                            }
                            return true;
                        });
                    }
                });
            }
        },
        clearFilter(){
            this.filteredDcList = this.tableData;
            this.filterQuery = null;
        },
        showLocations(data){
            this.locationDialogHeader = data.name;
            this.locationDialog = true;
            this.itemDeliveryLocations = data.location;
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 5000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      },
    }
}
</script>

<style>

</style>